import ar from './ar.json';
import en from './en.json';

/**
 * The kit's OWN strings — table chrome, pagination, filters, upload, confirm.
 *
 * The kit never contains a domain string. Every column header, filter label,
 * row-action label, field label and empty-state title is a prop the CALLER
 * translates from its own module namespace. That split is what keeps the kit
 * reusable across modules, and the module specs assert it.
 */
export const uiKitCatalogs = { ar, en };
